import React from 'react';
import LineChart, {chartContent} from "../../../../common/component/LineChart";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../../Common/util/ProcService";

const TodaySizeDashBoard: React.FC = () => {
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   ["todayCountDashboradKey"];
    const { data } = useCommonUseQuery<chartContent>(
        queryKey,
        () =>procAdminService<chartContent>("post", `${serviceCode}ADS01`, null));

    const todayCategory = [
                                    '00','01','02','03','04','05',
                                    '06','07','08','09','10','11',
                                    '12','13','14','15','16','17',
                                    '18','19','20','21','22','23',
                                    ]

    const todaySeries:chartContent[] = [
                                        data ||
                                        {
                                            name: "오늘",
                                            data: [
                                                0, 0, 0, 0, 0, 0,
                                                0, 0, 0, 0, 0, 0,
                                                0, 0, 0, 0, 0, 0,
                                                0, 0, 0, 0, 0, 0,
                                            ]
                                        },
                                    ]



    return (
                <LineChart title="오늘업로드 현황 (용량-MB)" unit="MB" categories={todayCategory} series={todaySeries} dataLabels={true}/>
    );
};

export default TodaySizeDashBoard;
